export default __webpack_public_path__ + "static/media/arrow-up.da67851b.svg";